import { Card, CardContent, View, Image } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import CalendarChecklist from "@/assets/images/3d-icons/calendar-checklist.png";

interface AppointmentScheduledCardProps {
  bookingDate: string;
  isAdHoc?: boolean;
}

export const AppointmentScheduledCard = ({
  bookingDate,
  isAdHoc = true,
}: AppointmentScheduledCardProps) => {
  if (!bookingDate) return null;

  const description = isAdHoc
    ? "Invoice will be issued after your service is completed."
    : "Invoice will be issued after each session.";

  return (
    <Card className="shadow-slate-200" border="none" shadow="lg">
      <CardContent className="px-4 py-4 md:px-6">
        <View className="flex flex-row items-start gap-3">
          <View className="h-6 w-6 flex-shrink-0">
            <Image src={CalendarChecklist} className="w-full" />
          </View>
          <View className="flex flex-1 flex-col gap-1">
            <Typography variant="label-sm" color="foreground-default">
              {bookingDate}
            </Typography>
            <Typography variant="caption-md" color="foreground-intermediate">
              {description}
            </Typography>
          </View>
        </View>
      </CardContent>
    </Card>
  );
};
